/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { quarterComparator } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import { cellRendererFourDec } from '../../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

// grid on first Scrren
export const mfgForRcddColoumData = [
  {
    headerName: 'Manufacturer ID',
    field: 'id',
    editable: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
// grid on second Screen
export const displayCurrentDisputes = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    cellRenderer: 'NDCCellRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DrugNameRenderer',
    cellClass: 'frr-ellipsis-text',
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Disp Cd 1',
    field: 'ccDisputeCd1',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Disp Cd 2',
    field: 'ccDisputeCd2',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Disp Cd 3',
    field: 'ccDisputeCd3',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: cellRendererFourDec,
    printPrefixValue: '',
    minWidth: Styles.Width_120,
    comparator: amountComparator,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    exportZeroesFour: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    //  exportZeroesFour: true,
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedUnits',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellRenderer: cellRendererFourDec,
    printPrefixValue: ' ',
    exportZeroesFour: true,
    comparator: amountComparator,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    // exportZeroesFour: true,
  },
  {
    headerName: 'Paid Units',
    field: 'paidUnits',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    exportZeroesFour: true,
    cellRenderer: cellRendererFourDec,
    printPrefixValue: ' ',

    comparator: amountComparator,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    // exportZeroesFour: true,
  },
  {
    headerName: 'Current URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    excelAlignment: 'right',
    exportZeroesFour: true,
    cellRenderer: cellRendererFourDec,
    printPrefixValue: ' ',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    // exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Dispute Amt',
    field: 'dispAmount',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    comparator: amountComparator,
    cellRenderer: 'dispAmountCellRenderer',
    sortingOrder: ['desc', 'asc'],
    // exportZeroesTwo: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    cellRenderer: 'interestDueCellRenderer',
    comparator: amountComparator,
    sortingOrder: ['desc', 'asc'],
    //  exportZeroesTwo: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
];
// grid on Provider Summary Screen
export const providerAndClaimColoumData = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Provider ID Type',
    field: 'providerIdType',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'providerId',
    sort: 'asc',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Select For Review',
    field: 'reviewSelect',
    editable: false,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,

    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'CheckBoxSelectedForRCellRender',
  },
  {
    headerName: 'Review Complete',
    field: 'reviewComplete',
    editable: false,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'CheckBoxReviewCompliteCellRender',
  },
  {
    headerName: 'Claim Count',
    field: 'claimCount',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Units',
    field: 'totalUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Amt Submitted',
    field: 'totalAmtSubmitted',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'totalAmtSubmittedCellRender',
    isTextColorRed: true,
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Total Amt Allowed',
    field: 'totalAllowedAmt',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    comparator: amountComparator,
    cellRenderer: 'totalAllowedAmtCellRender',
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Total Amt Reimbursed',
    field: 'totalAmtReimbursed',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    comparator: amountComparator,
    cellRenderer: 'totalAmtReimbursedCellRender',
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: '% Pd of Alw',
    field: 'pdOfAlw',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '% Alw of Sub',
    field: 'alwOfSub',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '% Pd of Sub',
    field: 'pdOfSub',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amt Paid Per Unit',
    field: 'amtPaidPerUnit',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'amtPaidPerUnitCellRender',
    isTextColorRed: true,
    comparator: amountComparator,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Amt Paid Per Prescription',
    field: 'amtPaidForPrescription',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'amtPaidForPrescriptionCellRender',
    comparator: amountComparator,
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Provider Name',
    field: 'providerName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'ProviderNameRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
// grid on NDC History Scrren
export const DrugActivityGridColData = [
  {
    headerName: 'Activity Type',
    field: 'drugActivityTypeCd',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_380,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Activity Date',
    field: 'drugActivityDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Effective Quarter',
    field: 'invoiceQtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    comparator: quarterComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Number Of Units ',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Change Of Units',
    field: 'changeNumOfUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code',
    field: 'disputeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_171,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dollar Amt',
    field: 'changeAmt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'changeAmtCellRender',
    dataAlignRight: true,
  },
];
// coloum detail of disputed Claim Detail Screen for ALL
export const DCDColDataForAll = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Provider ID Type',
    field: 'providerIdType',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'providerId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'ProviderIdRender',

    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Date',
    field: 'paidDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Select For Review',
    field: 'ccSelectReview',
    editable: false,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'CheckBoxCellRender',
  },
  {
    headerName: 'Reimburse Amt',
    field: 'reimbursementAmt',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    cellRenderer: 'ReimbursementAmtCellRender',
  },
  {
    headerName: 'Number Of Units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim ID',
    field: 'claimId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim Line Number',
    field: 'claimLineNum',
    editable: false,
    sortable: true,

    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Category',
    field: 'claimCategoryCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Patient ID',
    field: 'patientId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_190,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Patient Name',
    field: 'firstName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_290,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'PatientNameRenderer',
  },
  {
    headerName: 'Age',
    field: 'patientAge',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Sex',
    field: 'patientGenderCd',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prescription Number',
    field: 'prescriptionNum',
    editable: false,
    sortable: true,
    autoHeight: true,
    wrapText: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Service Date',
    field: 'serviceDt',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'DAW',
    field: 'dawInd',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Supplied Days',
    field: 'suppliedDays',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number Of Refills',
    field: 'numOfRefills',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Submitted Amt',
    field: 'submittedAmt',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    cellRenderer: 'SubmittedAmtCellRender',
  },
  {
    headerName: 'Allowed Amt',
    field: 'allowedAmt',
    editable: false,
    sortable: true,
    isTextColorRed: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'AllowedAmtCellRender',
    dataAlignRight: true,
  },
  {
    headerName: 'TPL Amt',
    field: 'tplAmt',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'tplCellRenderer',
    dataAlignRight: true,
  },
  {
    headerName: 'Copay Amt',
    field: 'copayAmt',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    sortingOrder: ['desc', 'asc'],
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: 'copayCellRenderer',
    dataAlignRight: true,
  },
];
